/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for finalizing event meetings after scheduled end time.

This job runs after meetings have ended and ensures reliable completion:
- If BOTH lecturer AND student joined at any point: mark COMPLETED, task DONE, auto-submit module
- If ONLY lecturer joined (student no-show): leave for no-show handling

Two-tier approach to avoid finalizing meetings still in progress:
- Tier 1 (grace_minutes): Only finalize if meeting_ended_at IS set (everyone left)
- Tier 2 (force_grace_minutes): Force finalize even without meeting_ended_at (catch lost webhooks)

Teams oral exams complete only when an imported transcript exists in Flare; roster
presence alone is not evidence. LiveKit and non-recording events keep the tier rules above.

grace_minutes: time after end_time for Tier 1 finalization (default 15min)
force_grace_minutes: time after end_time for Tier 2 forced finalization (default 120min)
slot_close_lookback_days: how far back to sweep for AVAILABLE slots past their end_time
                          and mark them COMPLETED (default 30 days)
 */
export interface MeetingsEventCompletionFinalizeParams {
  graceMinutes?: number;
  forceGraceMinutes?: number;
  slotCloseLookbackDays?: number;
}
